import { END_POINTS } from "constants/APIConstant";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { loadNotification, notificationIsRead } from "redux/actions/Notifications";
import { READ_NOTIFICATION, REQUEST_NOTIFICATION } from "redux/constants/Notifications";
import Services from "services/ApiService";
export function* readNotification() {
  yield takeLatest(READ_NOTIFICATION, function* ({notificationId}) {
    try {
       const response = yield call(Services.updateData, {
        url: `${END_POINTS.NOTIFICATION_READ}?notificationId=${notificationId}`,
      });
      if (response.status) {
        yield put(notificationIsRead(notificationId));
      }
    } catch (err) {}
  });
}
export function* getNotifications() {
  yield takeLatest(REQUEST_NOTIFICATION, function* () {
    try {
      const response = yield call(Services.fetchData, END_POINTS.NOTIFICATION_READ_TOP_NOTIFICATION);
      if (response.status) {
        yield put(loadNotification(response.data));
      } else {
        yield put();
      }
    } catch (err) {
    }
  });
}
export default function* rootSaga() {
  yield all([fork(readNotification),fork(getNotifications)]);
}
